<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>委托订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="position: static;float: left">
        <label style="color: orange">委托ID：</label>
        <el-input
            placeholder=""
            clearable
            v-model="queryData.orderId"
        >
        </el-input>
        <label style="color: orange">账户ID：</label>
        <el-input
            placeholder=""
            clearable
            v-model="queryData.uid"
        >
        </el-input>
        <label style="color: orange">交易对：</label>
        <el-select :value="queryData.pair" @change="setPair" placeholder="请选择">
          <el-option
              v-for="item in pairs"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
        <label>类型：</label>
        <el-select :value="queryData.type" @change="setQueryType2" placeholder="请选择">
          <el-option
              v-for="item in queryType2"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <label>方向：</label>
        <el-select :value="queryData.direction" @change="setQueryType3" placeholder="请选择">
          <el-option
              v-for="item in queryType3"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <label>状态：</label>
        <el-select :value="queryData.state" @change="setQueryType4" placeholder="请选择">
          <el-option
              v-for="item in queryType4"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
            type="datetimerange"
            value-format="timestamp"
            v-model="timeRange"
            start-placeholder="起始时间"
            end-placeholder="终止时间"
        >
        </el-date-picker>
        <el-button
            type="primary"
            @click="handleSearch"
        >搜索
        </el-button>
        <el-button
            type=""
            @click="reset"
        >重置
        </el-button>

      </div>
      <div style="color: red">
        * 请填写黄色筛选条件中的任意一个条件，不填写筛选条件将无法正常筛选
      </div>
      <div class="preview-opration" style="float: right;right: 0px; white-space:nowrap">
        <el-button style="margin-right: 35px" icon="" type="primary" @click="cancelOrder()">
          撤单
        </el-button>
      </div>

      <el-table :data="list" ref="multipleTable">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="委托订单ID"></el-table-column>
        <el-table-column prop="userId" label="账户ID"></el-table-column>
        <el-table-column prop="pair" label="交易对"/>
        <el-table-column prop="direction" label="方向">
          <template slot-scope="scope">
            {{ scope.row.direction === "BID" ? "买入" : "卖出" }}
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            {{ scope.row.orderType === "MARKET" ? "市价" : "限价" }}
          </template>
        </el-table-column>
        <el-table-column prop="emailGroupId" label="状态">
          <template slot-scope="scope">
            {{ getStatus(scope.row.status) }}
          </template>
          <!--          订单状态 NORMAL(0), 完全成交(1), 已撤销(2),部分成交(3)-->
        </el-table-column>
        <el-table-column prop="price" label="成交均价/委托价格">
        </el-table-column>
        <el-table-column prop="dealAmount" label="成交数量/委托数量">
        </el-table-column>
        <el-table-column label="成交金额/委托金额" prop="totalAnchorCoin">
        </el-table-column>
        <el-table-column label="手续费">
          <template slot-scope="scope">
            {{ (scope.row.totalAnchorCoin * scope.row.feeRate) }}
          </template>
        </el-table-column>
        <el-table-column label="委托时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
        <el-table-column label="结束时间">
          <template slot-scope="scope">
            {{ scope.row.updateTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="queryData.size"
                     :current-page="queryData.page" @current-change="changePage"/>
    </el-card>
  </div>
</template>

<script>
import '../store';
import api from '../api';

export default {
  name: 'order',
  props: {dataList: Array, pair: String},
  data() {
    return {
      list: [],
      pairs: [],
      total: 0,
      queryType2: [{label: "限价", value: "LIMIT"}, {label: "市价", value: "MARKET"}],
      queryType3: [{label: "买入", value: "BID"}, {label: "卖出", value: "ASK"}],
      queryType4: [{label: "NORMAL", value: 0}, {label: "完全成交", value: 1}, {label: "已撤销", value: 2}, {
        label: "部分成交",
        value: 3
      }],
      timeRange: [new Date().getTime()-24 * 90 * 60 * 60 * 1000,new Date().getTime()],
      queryData: {
        uid: "",
        orderId: "",
        type: "",
        from: null,
        to: null,
        direction: "",
        state: null,
        pair: "",
        size: 10,
        page: 1
      }
    };
  },
  methods: {
    changePage: function (currentPage) {
      this.queryData.page = currentPage;
      this.handleSearch();
    },
    setPair: function (select) {
      this.queryData.pair = select;
    },
    setQueryType2: function (select) {
      this.queryData.type = select;
    },
    setQueryType3: function (select) {
      this.queryData.direction = select;
    },
    setQueryType4: function (select) {
      this.queryData.state = select;
    },
    handleSearch: function () {

      if (!this.queryData.orderId && !this.queryData.uid && !this.queryData.pair){
        this.$message.error("请填写黄色筛选条件中的任意一个条件，不填写筛选条件将无法正常筛选");
        return;
      }

      if (this.timeRange===null){
        this.$message("查询时间不能为空")
        return;
      }

      if (this.timeRange[0]>=this.timeRange[1]){
        this.$message('开始时间需小于等于截止时间');
        return;
      }


      if (this.timeRange[1]>new Date().getTime()){
        this.$message('截止时间 不能大于当前时间');
        return;
      }

      this.queryData.from = this.timeRange[0];
      this.queryData.to = this.timeRange[1];


      api.getOrder(this.queryData).then(response => {
        if (response.code == 0) {
          this.list = response.data.data;
          this.total = response.data.total;

          console.log(this.total)
        } else {
          alert("查询失败");
        }
      });

    },
    getStatus: function (status) {
      switch (status) {
        case 0:
          return "NORMAL";
        case 1:
          return "完全成交";
        case 2:
          return "已撤销";
        case 3:
          return "部分成交";
        default:
          return "";
      }
    },
    cancelOrder: function () {
      alert('历史委托无法撤单');
    },
    reset: function () {
      this.list = [];
      this.queryData={
        uid: "",
        orderId: "",
        type: "",
        from: null,
        to: null,
        direction: "",
        state: null,
        pair: "",
        size: 10,
        page: 1
      };
    }


  },
  created() {
    api.getAllPair().then(response => {
      if (response.code == 0) {
        this.pairs = response.data;
      } else {
      }
    })
  }
};
</script>


